import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  container: {
    width: '480px',
  },
  label: {
    textAlign: 'left',
    paddingBottom: '16px',
    margin: 0,
  },
  explanation: {
    backgroundColor: (theme) => theme.palette.secondary.light,
    border: '1px dashed rgba(144, 144, 144, 0.4)',
    padding: '8px',
    display: 'flex',
    textAlign: 'left',
  },
  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '32px',
    gap: '16px',
  },
});
